import { CloudOff, HelpCircle, History, Wifi, WifiOff } from 'lucide-react'
import type { ReactNode } from 'react'

import type { ConnectionState, ConnectionVm } from '../model/connection'

const ICONS: Readonly<Record<ConnectionState, ReactNode>> = {
  online: <Wifi size={14} aria-hidden="true" />,
  stale: <History size={14} aria-hidden="true" />,
  unreachable: <WifiOff size={14} aria-hidden="true" />,
  unknown: <HelpCircle size={14} aria-hidden="true" />,
  'cabinet-unavailable': <CloudOff size={14} aria-hidden="true" />,
}

/**
 * Связь с кассой: значок, рамка и слова службы — состояние читается и в
 * `filter: grayscale(1)` (CLAUDE.md §7). Тексты службы — дословно.
 */
export function ConnectionLine({ connection }: { connection: ConnectionVm | null }) {
  if (connection === null) return null
  return (
    <div className="aqsi-connection" data-connection={connection.state} role="status" aria-label="Связь с кассой">
      <span className="aqsi-card__state">
        {ICONS[connection.state]}
        {connection.headline}
      </span>
      {connection.detail !== null && <p className="aqsi-card__text">{connection.detail}</p>}
    </div>
  )
}
